import Vue from 'vue';

import { buildFetchMutations } from '@/store/extensions/fetch';
import { buildCreateMutations } from '@/store/extensions/create';
import { buildUpdateMutations } from '@/store/extensions/update';
import { buildDeleteMutations } from '@/store/extensions/delete';

export default {
  ...buildFetchMutations(['fetchUsers', 'fetchSingleUser']),
  ...buildCreateMutations(['createUser']),
  ...buildUpdateMutations(['updateAccount', 'updatePassword', 'updateUser', 'updateCurrentUser']),
  ...buildDeleteMutations(['deleteUser']),

  // --- register action ---
  registerPending: (state) => {
    Vue.set(state, 'registering', true);
  },

  registerSuccess: (state) => {
    Vue.set(state, 'registering', false);
  },

  registerError: (state) => {
    Vue.set(state, 'registering', false);
  },

  // --- login action ---
  loginPending: (state) => {
    Vue.set(state, 'authenticating', true);
  },

  loginSuccess: (state, payload) => {
    Vue.set(state, 'authenticating', false);
    Vue.set(state, 'currentUser', payload);
  },

  loginError: (state) => {
    Vue.set(state, 'authenticating', false);
  },

  // --- getCurrentUser action ---
  getCurrentUserPending: (state) => {
    Vue.set(state, 'processing', true);
  },

  getCurrentUserSuccess: (state, payload) => {
    Vue.set(state, 'processing', false);
    Vue.set(state, 'currentUser', payload);
  },

  getCurrentUserError: (state) => {
    Vue.set(state, 'processing', false);
  },

  // --- logout action ---
  logoutPending: (state) => {
    Vue.set(state, 'loggingOutCurrentUser', true);
  },

  logoutSuccess: (state) => {
    Vue.set(state, 'loggingOutCurrentUser', false);
    Vue.set(state, 'currentUser', null);
  },

  logoutError: (state) => {
    Vue.set(state, 'loggingOutCurrentUser', false);
  },

  // --- validateToken action ---
  validateTokenPending: (state) => {
    Vue.set(state, 'validating', true);
  },

  validateTokenSuccess: (state, payload) => {
    Vue.set(state, 'validating', false);
    Vue.set(state, 'currentUser', payload);
  },

  validateTokenError: (state) => {
    Vue.set(state, 'validating', false);
  },

  // --- sendPasswordReset action ---
  sendPasswordResetPending: (state) => {
    Vue.set(state, 'processing', true);
  },

  sendPasswordResetSuccess: (state) => {
    Vue.set(state, 'processing', false);
  },

  sendPasswordResetError: (state) => {
    Vue.set(state, 'processing', false);
  },

  // --- updatePassword action ---
  updatePasswordPending: (state) => {
    Vue.set(state, 'processing', true);
  },

  updatePasswordSuccess: (state) => {
    Vue.set(state, 'processing', false);
  },

  updatePasswordError: (state) => {
    Vue.set(state, 'processing', false);
  },

  // --- allocateInitialTimeoff action ---
  allocateInitialTimeoffPending: (state) => {
    Vue.set(state, 'processing', true);
  },

  allocateInitialTimeoffSuccess: (state) => {
    Vue.set(state, 'processing', false);
  },

  allocateInitialTimeoffError: (state) => {
    Vue.set(state, 'processing', false);
  },

  // --- reallocatePto action ---
  reallocatePtoPending: (state) => {
    Vue.set(state, 'processing', true);
  },

  reallocatePtoSuccess: (state) => {
    Vue.set(state, 'processing', false);
  },

  reallocatePtoError: (state) => {
    Vue.set(state, 'processing', false);
  },

  // --- setPtoApprover action ---
  setPtoApproverPending: (state) => {
    Vue.set(state, 'processing', true);
  },

  setPtoApproverSuccess: (state) => {
    Vue.set(state, 'processing', false);
  },

  setPtoApproverError: (state) => {
    Vue.set(state, 'processing', false);
  },

  // --- setContext action ---
  setContext: (state, payload = null) => {
    Vue.set(state, 'context', payload);
  },

  updateCurrentUser: (state, payload = null) => {
    Vue.set(state, 'currentUser', payload);
  },

  openFormModal: (state, payload = null) => {
    Vue.set(state, 'formModalContext', payload);
    Vue.set(state, 'formModalOpened', true);
  },

  closeFormModal: (state) => {
    Vue.set(state, 'formModalOpened', false);
    Vue.set(state, 'formModalContext', null);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/user/mutations.js